import { useContext } from 'react';
import { useNavigate } from "react-router-dom";

import { AppContext } from "../../AppContext";

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';

import Assessment from '@mui/icons-material/Assessment';
import Schema from '@mui/icons-material/Schema';

import DataLoading from './../DataLoading';

const Home = () => {
  const isAuthenticated = Boolean(sessionStorage.getItem("isAuthenticated"));
  const loginUserStatus = Number(sessionStorage.getItem("loginUserStatus"));
   
  const navigate = useNavigate();
  const { embeddingData } = useContext(AppContext);

  //console.log("isAuthenticated: " + isAuthenticated);
  //console.log("loginUserStatus: " + loginUserStatus);
  //console.log("embeddingData.user: " + embeddingData.user);
  //console.log("embeddingData.tenantName: " + embeddingData.tenantName);

  /** 
  if (loginUserStatus == 0 && !isAuthenticated) {
    return (
      <Container maxWidth={false}>
        <Alert sx={{ border: 1, padding: 2, mx: 2, marginTop: 5 }} severity='info' >Click the LOGIN button in the upper right to get started.</Alert>
      </Container>
    )
  }
  */
 
  if (isAuthenticated && loginUserStatus >= 400  && !embeddingData.user) {
    return (
      <Container maxWidth={false}>
        <Alert sx={{ border: 1, padding: 2, mx: 2, marginTop: 5 }} severity='info' >Your account may not have been registered for dashboards. Please contact your adiministrator.</Alert>
      </Container>
    )
  }

  if (isAuthenticated && embeddingData.user && loginUserStatus >= 200  && !embeddingData.tenantName) {
    return (
      <Container maxWidth={false}>
        <Alert sx={{ border: 1, padding: 2, mx: 2, marginTop: 5 }} severity='info' >Your account may not have been assigned to a tenant. Please contact your adiministrator.</Alert>
      </Container>
    )
  }
  
  if (isAuthenticated && loginUserStatus >= 200 && embeddingData.workspaceArtifactsLoading) {
    return <DataLoading />
  }
  else if (isAuthenticated && loginUserStatus >= 200 && embeddingData.user  && embeddingData.tenantName) {
    return  (
      <Container maxWidth={false}>

        <Container maxWidth="xl">
          <Alert sx={{ border: 1, marginTop: 5 }} severity='info' >
            Now that you have logged in, you can use the left navigation menu to navigate to the reports accessible within this tenant.
          </Alert>

          <Typography variant='h6' component="h4" sx={{ mt: 2, mb: "6px" }} >Login Session Info:</Typography>

          <TableContainer component={Paper} sx={{ border: 1, backgroundColor: "#EEEEEE" }} >
            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small" >
              <TableBody>
                <TableRow key={"username"} >
                  <TableCell scope="row" sx={{ width: "200px" }} >
                    User Login:
                  </TableCell>
                  <TableCell><strong>{embeddingData.loginId}</strong></TableCell>
                </TableRow>
                <TableRow key={"name"} >
                  <TableCell scope="row" sx={{ width: "200px" }} >
                    User Display Name:
                  </TableCell>
                  <TableCell><strong>{embeddingData.user}</strong></TableCell>
                </TableRow>
                <TableRow key={"tenant"} >
                  <TableCell scope="row" sx={{ width: "200px" }} >
                    Tenant Name:
                  </TableCell>
                  <TableCell><strong>{embeddingData.tenantName}</strong></TableCell>
                </TableRow>
                <TableRow key={"userCanEdit"} >
                  <TableCell scope="row">
                    User can edit content:
                  </TableCell>
                  <TableCell><strong>{String(embeddingData.userCanEdit)}</strong></TableCell>
                </TableRow>
                <TableRow key={"userCanCreate"} >
                  <TableCell scope="row">
                    User can create content:
                  </TableCell>
                  <TableCell><strong>{String(embeddingData.userCanCreate)}</strong></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography variant='h6' component="h4" sx={{ mt: 2, borderBottom: 1, mb: "8px" }} >Tenant Contents</Typography>

          <Grid container >
            <Grid item xs={6} sx={{ pr: "4px" }} >
              <Box sx={{ fontSize: "1.25rem", color: "white", background: "linear-gradient(to bottom, #607D8B, #455A64, #607D8B )", padding: "4px", paddingLeft: "12px", borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }} >
                Reports
              </Box>
              <List sx={{ backgroundColor: "#EEEEEE", border: "1px solid #CCCCCC", pb: 0 }} >
                {embeddingData.reports &&
                  embeddingData.reports.map((report) => (
                    <ListItem key={report.id} divider dense >
                      <ListItemButton onClick={() => { localStorage.setItem("defaultreport", "/reports/" + report.id); navigate("/reports/" + report.id); }}>
                        <ListItemAvatar>
                          <Avatar sx={{ backgroundColor: "#607D8B" }} >
                            <Assessment />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={report.name} />
                      </ListItemButton>
                    </ListItem>

                  ))}
              </List>
            </Grid>
            <Grid item xs={6} sx={{ pl: "4px" }}>
              <Box sx={{ fontSize: "1.25rem", color: "white", background: "linear-gradient(to bottom, #607D8B, #455A64, #607D8B )", padding: "4px", paddingLeft: "12px", borderTopLeftRadius: "4px", borderTopRightRadius: "4px" }} >
                Datasets
              </Box>
              <List sx={{ backgroundColor: "#EEEEEE", border: "1px solid #CCCCCC", pb: 0 }} >
                {embeddingData.datasets &&
                  embeddingData.datasets.map((dataset) => (
                    <ListItem key={dataset.id} divider dense >
                      <ListItemButton onClick={() => { navigate("/reports/" + dataset.id); }}>
                        <ListItemAvatar>
                          <Avatar sx={{ backgroundColor: "#607D8B" }} >
                            <Schema />
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={dataset.name} />
                      </ListItemButton>
                    </ListItem>
                  ))}
              </List>
            </Grid>
          </Grid>
        </Container>
      </Container>
    )
  } 
}

export default Home;